import React from 'react';
import { getDateFromMillis } from './../utils/Utils';
import { makeStyles } from '@material-ui/core/styles';
import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import {
    Paper,
    Typography,
    Grid,
    Avatar,
    Chip,
    Slide,
    Snackbar,
    Button,
    LinearProgress
} from '@material-ui/core';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

const useStyles = makeStyles(theme => ({
    typography: {
        textAlign: "left",
    },
    panelDetails: {
        background: 'rgba(180, 180, 180, 1)',
    },
    paper: {
        padding: '10px 10px 10px 10px',
    },
    metricsPaper: {
        padding: '10px 10px 10px 10px',
        background: 'rgba(190, 190, 190, 1)',
    }
}));

function TransitionRight(props) {
    return <Slide {...props} direction="right" />;
}

function NotificationItem(props) {
    const classes = useStyles();
    const [open, setOpen] = React.useState(false);
    const [isLoading, setLoading] = React.useState(false);
    const [metrics, setMetrics] = React.useState([]);
    const [transition, setTransition] = React.useState(undefined);
    const [replies, setReplies] = React.useState(false);

    const handleClick = Transition => () => {
        setTransition(() => Transition);
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const handleMetricsClick = () => {
        setLoading(true);
        props.callback(props.id)
            .then(response => {
                console.log(response);
                showMetrics(response.data.data);
            })
            .catch(function (error) {
                console.log(error);
                alert(JSON.stringify(error));
            })
            .then(function () {
                // always executed
                console.log("call finished");
                setLoading(false);
            });
    };

    const handleRepliesDownloadClick = () => {
        setLoading(true);
        props.repliesCallback(props.id)
            .then(response => {
                console.log(response);
                window.open(response.data.sheetUrl);
            }).catch(function (error) {
                console.log(error);
            })
            .then(function () {
                // always executed
                console.log("call finished");
                setLoading(false);
            });
    }

    function showMetrics(data) {
        if (data) {
            let ret = []
            for (var index in data) {
                ret.push(<Typography key={index}>{index}: {data[index]}</Typography>);
            }
            setMetrics(ret);
            if (data.replied && data.replied > 0) {
                setReplies(true);
            }
        }
    }

    return (
        <div>
            <ExpansionPanel>
                <ExpansionPanelSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel1a-content" >
                    <Grid container
                        spacing={2}
                        direction="row"
                        justify="flex-start"
                        alignItems="flex-start">
                        <Grid item xs={5}>
                            <Typography className={classes.typography}>{props.title}</Typography>
                            <Typography className={classes.typography}>{props.text}</Typography>
                        </Grid>
                        <Grid item xs={4}>
                            <Typography>{props.id}</Typography>
                        </Grid>
                        <Grid item xs={3}>
                            <Typography>{props.date}</Typography>
                        </Grid>
                    </Grid>
                </ExpansionPanelSummary>
                <ExpansionPanelDetails className={classes.panelDetails}>
                    <Grid container
                        spacing={2}
                        direction="row"
                        justify="flex-start"
                        alignItems="flex-start">
                        <Grid item xs={9}>
                            <Paper className={classes.paper}>
                                <code>
                                    <Typography component="p" className={classes.typography}>
                                        {props.messageDetails}
                                    </Typography>
                                </code>
                                {adminChip(props.admin, handleClick(TransitionRight))}
                            </Paper>
                        </Grid>
                        <Grid item xs={3}>
                            <Paper className={classes.metricsPaper}>
                                <Button variant="contained" color="primary" onClick={handleMetricsClick}>
                                    <div>
                                        Retrieve metrics
                                        {isLoading ? <LinearProgress /> : null}
                                    </div>
                                </Button>
                                {metrics ? metrics : null}
                                {replies ? <Button variant="contained" color="secondary" onClick={handleRepliesDownloadClick}>
                                    <div>
                                        Download replies
                                        {isLoading ? <LinearProgress /> : null}
                                    </div>
                                </Button> : null}
                            </Paper>
                        </Grid>
                    </Grid>
                </ExpansionPanelDetails>
                {adminData(props.admin, open, handleClose, transition)}
            </ExpansionPanel>
        </div>
    );
}

const adminChip = (admin, clickAction) => {
    if (admin) {
        return (
            <Chip
                variant="outlined"
                onClick={clickAction}
                label={admin.name}
                avatar={<Avatar src={admin.icon} />}
            />
        );
    }
    return null;
}

const adminData = (admin, open, handleClose, transition) => {
    if (admin) {
        return (<Snackbar
            open={open}
            onClose={handleClose}
            autoHideDuration={5000}
            TransitionComponent={transition}
            ContentProps={{
                'aria-describedby': 'message-id',
            }}
            message={
                <div>
                    <Typography>Name: {admin.name}</Typography>
                    <Typography>ID: {admin.id}</Typography>
                    <Typography>Email: {admin.email}</Typography>
                </div>
            }
        />)
    }
    return null;
}

export const generateNotificationItem = (item, callback, repliesCallback) => {
    let payload = JSON.parse(item.payload);
    return (
        <NotificationItem
            key={item.id}
            title={payload.data.title}
            text={payload.data.text}
            id={item.id}
            admin={item.admin}
            callback={callback}
            repliesCallback={repliesCallback}
            date={getDateFromMillis(item.date)}
            messageDetails={item.payload}
        />
    );
}